export default __webpack_public_path__ + "static/icecream-taste-2-mobile-2d99f1e714b3bbb7049bbdee1ad002cd.png";